export default __webpack_public_path__ + "static/newCorpEnv2021-5aa4c8d69377fa65211c73c59e3be933.pdf";